/* source : http://michalsnik.github.io/aos/ */

import $ from 'jquery';
import AOS from "../../node_modules/aos/dist/aos.js";



$(document).ready(function () {

	//box home
	$("div[class*='box-']").attr("data-aos","fade-up");
	$("div[class*='box-']").attr("data-aos-delay","200");
	$("div[class*='box-']").attr("data-aos-anchor-placement","top-bottom");

	//home
	$(".page-index .featured-products").attr("data-aos","fade-up");
	$(".page-index .featured-products").attr("data-aos-delay","200");
	$(".page-index .featured-products").attr("data-aos-anchor-placement","top-bottom");

	//custom text
	$("#custom-text").attr("data-aos","fade-up");
	$("#custom-text").attr("data-aos-delay","200");
	$("#custom-text").attr("data-aos-anchor-placement","top-bottom");


	if (window.matchMedia("(min-width: 768px)").matches) {
		// Viewport is greater or equal than 768 pixels wide
		console.log("greater than 768px");
		$("div[class*='box-']:not([class*='box-two_items'])").attr("data-aos-offset","-500");
		$(".box-two_blocs.box-video.inverse").attr("data-aos-offset","-650");
		$(".box-two_items").attr("data-aos-offset","-1100");
		$("#custom-text").attr("data-aos-offset","-1200");
	}else {
		console.log("less than 768px");
	}

   AOS.init({
   		duration: 1000,
      delay:1000,
      placement:"top-center",
      /*disable: function() {
		    var maxWidth = 1200;
		    return window.innerWidth < maxWidth;
  		}*/
    });
});